import { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { HeadingProps } from '../shared/typography/Heading/common/styles';

// Načítanie všetkých obrázkov
const images = import.meta.glob<{ default: string }>('../assets/images/**/*.{png,jpg,jpeg,svg}');

interface IImagesLoader {
	height?: string | number;
	image: string;
	maxHeight?: string;
	maxWidth?: string;
	onClick?: () => void;
	path?: string;
	width?: string | number;
}
const ImageContainer = styled.img.withConfig({
	shouldForwardProp: (prop) => prop !== 'maxWidth' && prop !== 'maxHeight',
})<{ maxWidth?: string; maxHeight?: string }>`
	${({ maxWidth }) =>
		maxWidth &&
		css`
			max-width: ${maxWidth};
		`}

	${({ maxHeight }) =>
		maxHeight &&
		css`
			max-height: ${maxHeight};
		`}
`;

const LocalImagesLoader = ({ image, height = '100%', width = '100%', path = 'products', maxWidth, maxHeight, onClick }: IImagesLoader) => {
	const [imageSrc, setImageSrc] = useState<string>('');

	useEffect(() => {
		const loadImage = async () => {
			const imagePath = `../assets/images/${path}/${image}`;
			if (images[imagePath]) {
				try {
					const module = await images[imagePath]();
					setImageSrc(module.default);
				} catch {
					setImageSrc('');
				}
			} else {
				setImageSrc('');
			}
		};

		loadImage();
	}, [image]);

	return <ImageContainer alt={image} height={height} maxHeight={maxHeight} maxWidth={maxWidth} onClick={onClick} src={imageSrc} width={width} />;
};

export default LocalImagesLoader;
